import { coreService } from "../services/coreService";
import { buildQuery } from "../lib/network";

export const getReports = (headers: any) => (reportType: string) => {
  return buildQuery(coreService.reportsList({ reportType }, { headers }), (data) => {
    return data;
  });
};
